import { capturedGet, capturedPost, capturedRemove, capturedPut } from '../../http';

const state = {};
const getters = {};
const mutations = {};
const actions = {
  async removeGroup (context, { platform, id }) {
    return await capturedRemove(`/${platform}/global-order/stop/${id}`)
  },
  async batchStartAndStopGroup (context, { platform, isStart, ids }) {
    return await capturedPost(`/${platform}/global-order/${isStart ? 'batchstart' : 'batchstop'}`, { ids })
  },
  async getGroups (context, { platform, params }) {
    return await capturedGet(`/${platform}/global-order`, params)
  },
  async getSelectData (context, { platform }) {
    return await capturedGet(`/${platform}/global/adgroup/selectlist`)
  },
  async getJumpTypes (context) {
    return await capturedGet('/interface/etcd/item/jump_type_2.5')
  },
  async getAdUsers (context, { platform }) {
    return await capturedGet(`/${platform}/ads/ad/adselect`)
  },
  async submitForm (context, { platform, type, id, form }) {
    const requestMethod = type === 'edit' ? capturedPut : capturedPost
    return await requestMethod(`/${platform}/global-order${type === 'edit' ? '/' + id : ''}`, form)
  },
  async created (context, { platform, id }) {
    return await capturedGet(`/${platform}/global-order/${id}`)
  },
  async validateOrderName (context, { platform, value }) {
    return await capturedGet(`/${platform}/global-order/is-repeated`, { order_name: value })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
};
